
//= ===== MEDIA QUERY VARIABLES ======//
export const tabletMaxWidth = '770px';
export const mobileMaxWidth = '575px';
export const mediumMaxWidth = '960px';
export const deskTopMaxWidth = '1000px';
export const largeWidth = '1400px';
export const extraLargeWidth = '1500px';